import { Box, Button, ButtonBase, Container, Grid, Stack, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';

import supportimg from "../../assets/images/supportimg.png";
import Bottom from "../Bottom";
import { FormContainer, TextFieldElement } from "react-hook-form-mui";
import Top from "../Top";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import api from "../../utils/api";
import { notifyApiError } from "../../utils/apiError";

const questionInit = {
  id: '',
  title: '',
  content: '',
  createDate: '',
  answer: '',
  type: '',
  category: '',
  answerDate: '',
  memberId: '',
  image_url: ''
}


const SupportCreateQuestion = () => {
  const navigate = useNavigate();
  const [contentLength, setContentLength] = React.useState(0);
  const [question, setQuestion] = React.useState(questionInit);

  useEffect(() => {
    // getQuestion();
  }, []);

  function getQuestion() {
    // api.get(`app/api/v1/AP_003_002?support_id=${supportId}`).then(res => {
    //   setQuestion(res.data.result_data.support_item);
    //   setContentLength(res.data.result_data.support_item.content.length);
    // }).catch(function (error) {
    //   console.log(error)
    // });
  }

  function handleClickCreateQuestion(data: any) {
    const sendItems = {
      cusId: localStorage.getItem('userCusID'),
      title: data.title,
      question: data.content,
    }

    api.post(`customer/api/v1/CU_008_002`, sendItems).then((res: any) => {
      alert('문의 등록이 완료되었습니다.');
      navigate('/Notice/SupportQuestion');
    }).catch(function (error) {
      notifyApiError(error, '문의를 등록하지 못했습니다.');
    });
  }
 
  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 10, pb: 10, minWidth: 320 }}>
      <Top title='1:1 문의 등록' />

      <FormContainer
        values={{
          title: question.title, content: question.content
        }}
        onSuccess={data => handleClickCreateQuestion(data)}
      >

        <Box
          component="form"
          sx={{
            mt: 4,
            '& > :not(style)': { m: 0, mb: 3, width: '100%' },
          }}
          noValidate
          autoComplete="off"
        >
          <TextFieldElement
            name="title"
            id="input-title" label="제목"
            fullWidth
            onChange={(e: any) => {
              setQuestion((prev) => true ? { ...prev, title: e.target.value } : prev);
            }}
            multiline
            maxRows={2}
            inputProps={{ maxLength: 50, value: question.title }}
            rules={{
              required: '제목은 필수 입력입니다.',
            }}
            sx={{
              '& .MuiInputBase-root': { bgcolor: '#fff' },
              '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused': { color: '#ec8122' },
              '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#ec8122' }
            }}
          />
          <TextFieldElement
            name="content"
            id="input-content" label="내용"
            fullWidth
            onChange={(e: any) => {
              setQuestion((prev) => true ? { ...prev, content: e.target.value } : prev);
              setContentLength(e.target.value.length);
            }}
            multiline
            rows={12}
            inputProps={{ maxLength: 250, value: question.content }}
            rules={{
              required: '내용은 필수 입력입니다.',
            }}
            sx={{
              '& .MuiInputBase-root': { bgcolor: '#fff' },
              '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused': { color: '#ec8122' },
              '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#ec8122' }
            }}
          />
        </Box>
        <Typography sx={{ fontSize: 12, color: '#777', textAlign: 'right', mt: -2 }}>({contentLength}/250자)</Typography>

        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle} type={'submit'}>
            등록
          </Button>
        </Box>

      </FormContainer>

      <Bottom />
    </Container>
  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 3,
  boxSizing: 'border-box',
  pb: 3
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default SupportCreateQuestion;